import { MenuDto } from "src/types/base";
import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { UserResponseDto } from "../dtos/user/response/userResponseDto";
import { UserSimpleResponseDto } from "../dtos/user/response/userSimpleResponseDto";
import { getData, patchData } from "../utils/axios/serverHelper";
import { BookmarkCdList } from "src/store/useCommonCodeStore";
import { encryptPassword } from "../utils/auth/passwordEncrypt";

const baseUrl = `${config.apiUrl}/user`;

export const getUserBySearch = async (keyword: string) => {
    const url = `${baseUrl}`

    return await getData<ResponseDto<UserSimpleResponseDto[]>>(url, {
        params: { keyword }  
    });
}

export const getUserDetail = async (empNo: string) => {
    const url = `${baseUrl}/info`
    return await getData<ResponseDto<UserSimpleResponseDto>>(url, {
        params: { empNo }
    });
}

export const getMyInfo = async () => {
    const url = `${baseUrl}/me`;
    return await getData<ResponseDto<UserResponseDto>>(url);
}

export const changeMyPassword = async (currentPassword: string, newPassword: string) => {
	const url = `${baseUrl}/password`;

	return await patchData<{ currentPassword: string; newPassword: string }, ResponseDto<any>>(url, {
		currentPassword: encryptPassword(currentPassword),
		newPassword: encryptPassword(newPassword)
	});
}